import React, { useState } from 'react';
import { GET_DOCUMENTS_FROM_PC_getDocumentsFromPC_documentsList as account_documents_item } from './graphql/__generated__/GET_DOCUMENTS_FROM_PC';
import AlertLoader from '../../components/gpaCancelPolicy/AlertLoader';
import { WarningText } from '../../components/gpaCancelPolicy/RefundMethodsStyles';
import DocumentsTable from '../../components/documentsInfoTable/DocumentsTable';

export interface GET_POLICIES_BY_ACCOUNT_account_items_policies_items {
  __typename: "Policy";
  policy_type: string | null;
  policy_number: string | null;
  expiration_date: any | null;
  
}

export interface DocumentsInfoPageProps {
  isLoading?: boolean;
  error?: Error;
  accountNumber: string;
  information: account_documents_item[] | [];
  policies: GET_POLICIES_BY_ACCOUNT_account_items_policies_items[] | [];
  downloadDocument: Function;
}

export const DocumentsInfoPage = ({
  isLoading,
  error,
  accountNumber,
  information,
  policies,
  downloadDocument
}: DocumentsInfoPageProps) => {
  if (isLoading) return <AlertLoader message="Loading Documents" />;
  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <WarningText>
          {' '}
          There is no Documents data available at this moment, please try again
          later.
        </WarningText>
      </div>
    );
  }
  const props = {
    documents: information,
    accountNumber,
    policies: policies,
    downloadDocument
  };

  return <DocumentsTable {...props} />;
};
